import { render, staticRenderFns } from "./TextAlignTopIcon.vue?vue&type=template&id=3157426b&"
import script from "./TextAlignTopIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignTopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports